import styles from "./LineupSelectionComponent.module.css";
import { globals, images } from "../../styles";
import { vinyl_Icon } from "../../assets/icons";
import { useUserId } from "../../hooks/useUserId";
import { usePlayerLineups, usePlayerStats } from "../../hooks/player";
import { useCurrentDraft } from "../../hooks/drafts";
import LoadingSpinner from "../LoadingSpinner";
import { lineupCount } from "../../constants";
import { JSX } from "react";
import { currencyFormatter } from "../../helpers";

function LineupSelectionComponent(props: {
  username: string;
  handleNewLineup: (lineupIndex: number) => void;
  handleSelectLineup: (lineupIndex: number) => void;
}) {
  const { username, handleNewLineup, handleSelectLineup } = props;
  const userId = useUserId();
  const { data: currentDraft } = useCurrentDraft();

  const { data: playerStats, isPending: isStatsLoading } =
    usePlayerStats(userId);
  const { data: playerLineups, isPending: isLineupsLoading } = usePlayerLineups(
    userId,
    { draftId: currentDraft?.draftId },
  );

  if (isStatsLoading || !playerStats || isLineupsLoading || !playerLineups) {
    return <LoadingSpinner />;
  }

  function renderLineups() {
    const elements: JSX.Element[] = [];
    for (let i = 0; i < lineupCount; i++) {
      const lineup =
        playerLineups && i < playerLineups.lineups.length
          ? playerLineups.lineups[i]
          : false;
      elements.push(
        <button
          key={i}
          className={globals["button-wrapper"]}
          onClick={
            lineup
              ? () => handleSelectLineup(lineup.lineupIndex)
              : () => handleNewLineup(i + 1) // Lineups are indexed from 1
          }
        >
          {!lineup ? (
            <div
              className={`${styles["entry"]} ${styles["entry--placeholder"]}`}
            >
              <span className={styles["placeholder-plus"]}>+</span>
              <img
                className={images["vinyl-btn-icon"]}
                src={vinyl_Icon}
                alt=""
              />
            </div>
          ) : (
            <div className={styles["entry"]}>
              <div className={styles["entry-info"]}>
                <span className={styles["entry-name"]}>
                  {lineup.lineupName}
                </span>
                <span className={styles["entry-detail"]}>
                  Cash: {currencyFormatter(lineup.currentBudget)}
                </span>
                <span className={styles["entry-detail"]}>
                  Free trades: {lineup.freeTradesRemaining}
                </span>
              </div>
              <div className={styles["entry-points"]}>
                <img
                  className={images["vinyl-btn-icon"]}
                  src={vinyl_Icon}
                  alt=""
                />
                <span className={styles["entry-points-text"]}>
                  {lineup.totalScore} points
                </span>
              </div>
            </div>
          )}
        </button>,
      );
    }
    return elements;
  }

  return (
    <div className={styles["lineup-wrapper"]}>
      <div className={styles["lineup-banner"]}>
        <span className={styles["banner-title"]}>{username}'s Lineups</span>
        <span className={styles["banner-subtitle"]}>
          ✦ Total Lineup Score: {playerStats.totalScore} ✦
        </span>
      </div>
      <div className={styles["lineup-container"]}>
        <div className={styles["lineup-list"]}>{renderLineups()}</div>
      </div>
      <div className={styles["lineup-count-bar"]}>
        <span className={styles["lineup-count-text"]}>
          Lineups: {playerLineups.lineups.length}/{lineupCount}
        </span>
      </div>
    </div>
  );
}

export default LineupSelectionComponent;
